import type { DefaultValues } from "react-hook-form";
import type { FormValues } from "types/form.types";

export const getDefaultFormValues = (): DefaultValues<FormValues> => ({
  service_tool: "",
  service_type: "",
  first_name: "",
  last_name: "",
  email: "",
  message: "",
  company_name: "",
  phone: {
    dialCode: { name: "", value: "" },
    number: "",
  },
});
